import { EventEmitter, Injectable } from '@angular/core';
import {

  UserClient,
  UsersClient,
  
} from './api.service';
import {RefreshAuthenticationRequest} from 'src/app/models/refreshauthenticationrequest';
import {UserLoginRequest} from 'src/app/models/userloginrequest';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map, tap, catchError, first } from 'rxjs/operators';
import { Observable, throwError, of, from, Subject } from 'rxjs';
import { SettingsService } from './settings.service';
import { LoginClient } from '../clients/loginclient';
import{TokenResponse} from '../models/tokenresponse';
import{UserResponse}from '../models/UserReponse';
import { PasswordResetRequest } from "../models/PasswordResetRequest";
import{TokenClient} from '../clients/tokenClient';
import { Customer } from '../models/customer';
import { UserPinRequest } from '../models/userpinrequest';
import { OneTimePinClient } from '../clients/onetimepinclient';
//import { resolve } from 'path';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(
    private tokenClient: TokenClient,
    private usersClient: UsersClient,
    private userClient: UserClient,
    private settingsService: SettingsService,
    private loginClient:LoginClient,
    private _oneTimePicClient:OneTimePinClient
  ) {
    // to be removed after testing the refresh token

    //this.testRefreshToken();
   //
  }
  redirectUrl:string;
  async testRefreshToken()
  {
    setInterval(() => {
      this.resfrehTokenSubject.emit(true);
      let storedToken = JSON.parse(localStorage.getItem('userTokens'));
      const {exp, iat} : {exp: number, iat:number} = this.getParsedJwt(storedToken.token);
      console.log(exp);
      const jwttToken = new JwtHelperService(storedToken.token);
     //const isExpried = jwttToken.isTokenExpired(storedToken.token);
     //console.log(isExpried);
     
     this.tokenPromise = this.refreshAccessToken().toPromise();
     //await this.tokenPromise;
     this.tokenPromise.then(()=>{
      setTimeout(() => {
        this.resfrehTokenSubject.emit(false);
      }, 3000);
      
     }) 
     this.tokenPromise = undefined;
    }, 10000);
   
   //
  }
  resfrehTokenSubject = new EventEmitter<boolean>();
  public tokenPromise: Promise<TokenResponse | undefined> | undefined;

  isAuthenticated(): boolean {
    const tokens = localStorage.getItem('userTokens');
    if (tokens === null) {
      return false;
    }
    let storedToken = JSON.parse(localStorage.getItem('userTokens'));
    var res = UserResponse.fromJS(storedToken.user)
   
    if( res == null || res === undefined )
      return false;
    if(!storedToken.hasOwnProperty("user"))
      
      return false;
    
    if(storedToken.user.hasOwnProperty("userType"))
      return false;
   
    return tokens != null;
  }

  get Decode() {
    const tokenHelper = new JwtHelperService();
    return tokenHelper.decodeToken(this.getAccessToken());
  }

  get Role(): string {
   // const token = this.Decode;
   const token = this.getStoredToken();
    
    if(!token)
    return null;
    if (token !=null && token!=undefined && !token.hasOwnProperty('user')) {
      return null;
    }
   
    let user =UserResponse.fromJS(token.user);
    if(user.hasOwnProperty("userRole"))
    return token.user.userRole.userRoleName;
  return null;
  }

  get Fullname(): string {
    const token = this.getStoredToken();
    if (token != null && token != undefined && !token.hasOwnProperty('user')) 
      return null;
    
    return token.user.title+" "+token.user.firstName+" "+token.user.lastName;
  }
  /*
  get UserId(): number {
    const token = this.Decode;
    if (!token.hasOwnProperty('nameid')) {
      return null;
    }
    return token.CompanyId;
  }
*/
  get CompanyId(): number {
    const token = this.Decode;
    if (!token.hasOwnProperty('CompanyId')) {
      return null;
    }
    return token.CompanyId;
  }

  get Username(): string {
    //const token = this.Decode;
    const token=this.getStoredToken();
    if (token !=null && token!=undefined && !token.hasOwnProperty('user')) 
      return null;
    
    return token.user.userName;
  }
 

  get CurrentUserInfo(): Observable<UserResponse> {
    // Gets user info is all on token for now
    const token=this.getStoredToken();
    if(token.user && token.user.impersonatedUsers && token.user.impersonatedUsers.length>0)
    {
     
      token.user.impersonatedUsers.sort(function (a, b) {
        if (a.firstName < b.firstName) 
        return -1;
        if (a.firstName > b.firstName) 
        return 1;
        return 0;
          
      });
    }
    
   return of(UserResponse.fromJS(token.user));
  
  }
  set UpdateCurrentUserInfo(user:UserResponse)
  {
    const token=this.getStoredToken();
    token.user=user;
    this.StoreTokens(token);
  }
 _impersonateList:Array<UserResponse>=[] ;
 get ImpersonateList() : Observable<Array<UserResponse>>
 {
  // for now it will be hard coded...
   return of(this._impersonateList);
 }

  StoreTokens(tokens:any) {
   
    if (tokens && tokens.token ) {
      localStorage.setItem('userTokens', JSON.stringify(tokens));
    }
    if(tokens && tokens.user )
       localStorage.setItem('tempUser', JSON.stringify(tokens.user));
  }

  SendResetPassword(email: string) {
    return this.loginClient.sendRequestResetPassword(email);
  }

  ResetPassword(reset: PasswordResetRequest) {
    return this.loginClient.resetPassword(reset);
  }

  Logout() {
    localStorage.removeItem('userTokens');
    this.settingsService.clearSettings();
    sessionStorage.removeItem("breakGlass");
  }

  Login(loginInfo: UserLoginRequest) {
    return this.loginClient
      .authenticate(loginInfo)
      .pipe(tap(tokens => this.StoreTokens(tokens)));
  }
 validateOneTimePin(userPinDto:UserPinRequest){
     return this._oneTimePicClient.validateOneTimePin(userPinDto).pipe(tap(tokens => this.StoreTokens(tokens)));
 }
  refreshAccessToken(): Observable<TokenResponse> {
    const storedToken = JSON.parse(localStorage.getItem('userTokens'));
    const refreshToken = new RefreshAuthenticationRequest();
    refreshToken.token = storedToken.refreshToken;
    return this.tokenClient
      .refreshToken(refreshToken)
      .pipe(first(),tap(tokens => this.StoreTokens(tokens)));
    
  }

  async getAccessTokenPromise(): Promise<string> {
    let storedToken = JSON.parse(localStorage.getItem('userTokens'));
    const {exp, iat} : {exp: number, iat:number} = this.getParsedJwt(storedToken.token);
   
    // Half the time of the access token's expiry go trigger a refresh
    if ((Date.now() / 1000) + ((exp - iat) / 2) >= exp) {
      if (this.tokenPromise == undefined){
        this.resfrehTokenSubject.next(true);
        this.tokenPromise = this.refreshAccessToken().toPromise();
      }
      await this.tokenPromise;
      this.tokenPromise = undefined;
      this.resfrehTokenSubject.next(false);
      storedToken = JSON.parse(localStorage.getItem('userTokens'));
    }
    return storedToken.token;
  }

  getAccessToken(): string {
    if(localStorage.getItem('userTokens') !==null){
      
    let storedToken = JSON.parse(localStorage.getItem('userTokens'));
   
    return storedToken.token;
    }
    return null;
  }
  getStoredToken():TokenResponse
  {
    if(localStorage.getItem('userTokens') !==null){
      
      let storedToken = JSON.parse(localStorage.getItem('userTokens'));
      
      return storedToken;
      }
      return null;
  }
  getParsedJwt<T extends object = { [k: string]: string | number }>(token: string, ): T | undefined 
    
 {
    try {
      return JSON.parse(atob(token.split('.')[1]))
    } catch {
      return undefined
    }
  }
  updateCurrentUserCredentials(ishasCredentials:boolean)
  {
   let token = this.getStoredToken();
   token.user.hasProviderCredentials=ishasCredentials;
   this.StoreTokens(token);
  }
  getUserByTempToken(tempToken:string)
  {
    // call an api to check if the token is still active or not and return a user
    return this.loginClient.getUserByTempToken(tempToken);
  }
  updateCurrentUserCustomer(customer:Customer)
  {
    let token = this.getStoredToken();
   token.user.customer=customer;
   this.StoreTokens(token);
  }
}
